module.exports = __webpack_public_path__ + "img/gallery-1.33b39282.jpg";